var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slack__Property 1=Slack",
    className: "slack__Property slack__1=Slack"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slack__Integrations",
    className: "slack__Integrations"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slack__Frame 427321419",
    className: "slack__Frame slack__427321419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "slack__Group",
    className: "slack__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "slack__Vector",
    fill: "#36C5F0",
    fillRule: "evenodd",
    d: "M9.183 1.854a2.113 2.113 0 0 0-2.111 2.115 2.114 2.114 0 0 0 2.112 2.116h2.113V3.97a2.116 2.116 0 0 0-2.114-2.116c.001 0 .001 0 0 0Zm0 5.643h-5.63A2.114 2.114 0 0 0 1.44 9.613a2.114 2.114 0 0 0 2.111 2.116h5.632a2.114 2.114 0 0 0 2.113-2.116 2.114 2.114 0 0 0-2.113-2.116Z",
    className: "slack__Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "slack__Vector_2",
    fill: "#2EB67D",
    fillRule: "evenodd",
    d: "M22.56 9.613a2.114 2.114 0 0 0-2.113-2.116 2.114 2.114 0 0 0-2.112 2.116v2.116h2.112a2.114 2.114 0 0 0 2.112-2.116Zm-5.633 0V3.969a2.115 2.115 0 0 0-2.111-2.115 2.114 2.114 0 0 0-2.113 2.115v5.644a2.114 2.114 0 0 0 2.112 2.116 2.114 2.114 0 0 0 2.112-2.116Z",
    className: "slack__Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "slack__Vector_3",
    fill: "#ECB22E",
    fillRule: "evenodd",
    d: "M14.816 23.015a2.114 2.114 0 0 0 2.112-2.116 2.114 2.114 0 0 0-2.112-2.115h-2.113V20.9c0 1.166.945 2.114 2.113 2.115Zm0-5.644h5.632a2.114 2.114 0 0 0 2.112-2.116 2.114 2.114 0 0 0-2.111-2.116h-5.632a2.114 2.114 0 0 0-2.113 2.116c0 1.168.944 2.115 2.112 2.116Z",
    className: "slack__Vector",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "slack__Vector_4",
    fill: "#E01E5A",
    fillRule: "evenodd",
    d: "M1.44 15.256a2.114 2.114 0 0 0 2.112 2.116 2.114 2.114 0 0 0 2.113-2.116v-2.115H3.552a2.114 2.114 0 0 0-2.112 2.115Zm5.632 0V20.9a2.114 2.114 0 0 0 2.111 2.116 2.114 2.114 0 0 0 2.113-2.115v-5.643a2.112 2.112 0 1 0-4.224-.002Z",
    className: "slack__Vector",
    clipRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/Slack.658b56778729f836d0ccf19e5130d794.svg";
export { ForwardRef as ReactComponent };